<template>
	<div class="page">
		<navBar title="Privacy Policy" v-if='UTILS.getEnv() && showNav'></navBar>
		<div class="privacy-container" ref='priCon'>
			<img src="../../assets/img/privacy.png">
		</div>
	</div>
</template>

<script>
	import uni from '@/assets/js/webview.js'
	import navBar from "@components/navBar";
	export default {
		data() {
			return {
				showNav:false
			}
		},
		metaInfo: {
			title: 'Privacy Policy'
		},
		mounted() {
			this.showNav = this.UTILS.getQueryString("showNav") || false;
			if(this.UTILS.getEnv()){
				window.addEventListener('scroll', this.throttle(this.checkIfBottom, 200));
			}
		},
		methods: {
			throttle(func, delay) {
				let timer = null;
				return function() {
					if (!timer) {
						timer = setTimeout(() => {
							func.apply(this, arguments);
							timer = null;
						}, delay);
					}
				};
			},
			checkIfBottom() {
				const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
				const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				if (scrollTop + clientHeight + 10 >= scrollHeight) {
					try {
						uni.postMessage({
							data: {
								action: 'toBottom',
							}
						});
					} catch (e) {
						console.log(e)
					}
				}
			}
		},
		components:{
			navBar
		}
	}
</script>

<style scoped>
	.privacy-container{
		padding: 0.3rem;
	}
	h2{margin-bottom: 0.3rem;font-size: 0.30rem;}
	.cube-tab-bar{padding: 0 0 0.3rem 0.3rem;}
	p{font-size: 0.26rem;}
	.title{margin: 0.2rem 0;}
	.cube-tab-bar div{font-size: 0.26rem;}
	img{width: 100%;}
</style>
